'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.ProjektleiterSchema = {
  title: 'Projektleiter',
  type: 'object',
  properties: Object.assign({}, baseProperties, {
    startdatum: {
      type: 'string',
      format: 'maybe-naive-date'
    },
    enddatum: {
      type: 'string',
      format: 'maybe-naive-date'
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/projektleiter.js
// module id = 87fl
// module chunks = 0